export default {
	title: 'L\'arrivée de bébé',
	articles: {
		mois0: [
		],
		mois1: [
		],
		mois2: [
		],
		mois3: [
		],
		mois4: [
		],
		mois5: [
		],
		mois6: [
		],
		mois7: [
			11,12,13,14,15
		],
		mois8: [
			11,12,13,14,15
		],
		mois9: [
			11,12,13,14,15
		]
	}
};
